/* eslint-disable react/prop-types */
import React from 'react';
import { RichText } from '@fiverr-private/cms_ui';

import './styles.scss';
import { getEmbeddedComponents } from '../../constants';

export const LayoutBlock = (props) => (
    <div className="layout-block">
        {props.layoutItems.map((layoutItem, index) => (
            <RichText key={index} {...layoutItem.content} embeddedComponents={getEmbeddedComponents()} />
        ))}
    </div>
);
